import { render } from "./ModalEnviarPlanilha.vue?vue&type=template&id=1ae89cdb&scoped=true&ts=true"
import script from "./ModalEnviarPlanilha.vue?vue&type=script&lang=ts"
export * from "./ModalEnviarPlanilha.vue?vue&type=script&lang=ts"

import "./ModalEnviarPlanilha.vue?vue&type=style&index=0&id=1ae89cdb&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ae89cdb"]])

export default __exports__